import client from './client'

export interface WhenToSaveCsvChoice {
  value: number
  label: string
}

export interface WhenToSaveCsvSetting {
  value: number
  label: string
  choices: WhenToSaveCsvChoice[]
}

export interface OcrModelTypeChoice {
  value: string
  label: string
}

export interface OcrModelTypeSetting {
  value: string
  label: string
  choices: OcrModelTypeChoice[]
}

export interface UserSettings {
  when_to_save_csv: WhenToSaveCsvSetting
  use_legacy_ui: boolean
  read_qr_directly: boolean
  should_raise_gigi_alerts: boolean
  should_perform_reshape: boolean
  ocr_model_type?: OcrModelTypeSetting
  medication_number_confidence_threshold?: number
  prescription_display_days_back: number
}

export interface UserSettingsUpdateRequest {
  when_to_save_csv?: number
  use_legacy_ui?: boolean
  read_qr_directly?: boolean
  should_raise_gigi_alerts?: boolean
  should_perform_reshape?: boolean
  ocr_model_type?: string
  medication_number_confidence_threshold?: number
  prescription_display_days_back?: number
}

export const getUserSettings = async (): Promise<UserSettings> => {
  const response = await client.get('/api/settings/')
  return response.data
}

export const updateUserSettings = async (
  settings: UserSettingsUpdateRequest
): Promise<UserSettings> => {
  const response = await client.patch('/api/settings/', settings)
  return response.data
}
